import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";

//Routes
import Login from "../pages/Login/Login";
// import Test from "../pages/Test/Test";
// import OCR from "../components/OCR/OCR";
import OrderAssistantSandbox from "../pages/OrderAssistantSandbox/OrderAssistantSandbox";

const PublicRoutes = () => {
    const authStore = useSelector((s: any) => s.authStore)
    const navigate = useNavigate();

    useEffect(() => {
        if (authStore.isAuthenticated && (process.env.REACT_APP_ENVIRONMENT !== "DEVELOPMENT")) {
            if (window.location.pathname === "/") {
                navigate("/profile")
            }
            else {
                navigate(window.location.pathname + window.location.search)
            }
        }
    }, [authStore.isAuthenticated])

    return <>
        <Routes>
            <Route path="/" element={<Login />}> </Route>
            {/* <Route path="/test" element={<Test />}> </Route>
            <Route path="/ocr" element={<OCR />} /> */}
            <Route path="/order-assistant-sandbox" element={<OrderAssistantSandbox />} />
        </Routes>
    </>
}

export default PublicRoutes